export default __webpack_public_path__ + "static/media/BG-DarkBlue-0002.7fc0788a.png";